import { Injectable, computed, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ConsumerAudioPreferencesService {
  #muted = signal(false);
  #soundUnlocked = signal(false);

  readonly muted = computed(() => this.#muted());
  readonly soundUnlocked = computed(() => this.#soundUnlocked());

  isMuted(): boolean {
    return this.#muted();
  }

  setMuted(value: boolean): void {
    this.#muted.set(value);
    if (!value) {
      this.#soundUnlocked.set(true);
    }
  }

  toggleMuted(): boolean {
    const nextValue = !this.#muted();
    this.setMuted(nextValue);
    return nextValue;
  }

  resetSoundUnlocked(): void {
    this.#soundUnlocked.set(false);
  }

  isSoundUnlocked(): boolean {
    return this.#soundUnlocked();
  }

  unlockSound(): void {
    if (!this.#soundUnlocked()) {
      this.#soundUnlocked.set(true);
    }
  }
}
